(function () {
  'use strict';

  var CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"'
    + ' width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
    + ' stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">'
    + '<polyline points="20 6 9 17 4 12"/></svg>';

  var CART_SVG = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"'
    + ' width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
    + ' stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>'
    + '<line x1="3" y1="6" x2="21" y2="6"/>'
    + '<path d="M16 10a4 4 0 0 1-8 0"/>'
    + '</svg>';

  // Returns the element's bottom edge in document coordinates.
  // Uses offsetTop traversal — unaffected by position:sticky on ancestors.
  function docOffsetBottom(el) {
    var top = 0;
    var node = el;
    while (node && node !== document.body) {
      top += node.offsetTop;
      node = node.offsetParent;
    }
    return top + el.offsetHeight;
  }

  function showSuccess(btn) {
    var iconSpan = btn.querySelector('span.psc-icon');
    if (!iconSpan) return;
    iconSpan.innerHTML = CHECK_SVG;
    btn.classList.add('psc--success');
    setTimeout(function () {
      btn.classList.remove('psc--success');
      iconSpan.innerHTML = CART_SVG;
    }, 1600);
  }

  var pscTriggered = false;

  function init() {
    var btn = document.querySelector('.psc-btn');
    if (!btn) return;

    // Find the main product's submit button.
    // data-product-page-submit is set by buy-buttons.liquid when is_main_product=true.
    var submitBtn = document.querySelector('[data-product-page-submit]')
      || document.querySelector('[id^="MainProduct-"] [id^="ProductSubmitButton-"]');
    if (!submitBtn) return;

    // Delegate click to real form submit
    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      pscTriggered = true;
      setTimeout(function () { pscTriggered = false; }, 10000);
      submitBtn.click();
    });

    // Mirror disabled state
    var mutObs = new MutationObserver(function () {
      var disabled = submitBtn.getAttribute('aria-disabled') === 'true' || submitBtn.disabled;
      if (disabled) {
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
    });
    mutObs.observe(submitBtn, { attributes: true, attributeFilter: ['aria-disabled', 'disabled'] });

    // Hide while cart drawer (or any drawer) is open.
    // Dawn adds overflow-hidden to body when any drawer opens.
    var bodyObs = new MutationObserver(function () {
      btn.classList.toggle('psc--cart-open', document.body.classList.contains('overflow-hidden'));
    });
    bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // Scroll threshold: document bottom of the buy-buttons container.
    // Recalculated via offsetTop traversal so position:sticky doesn't distort it.
    var anchor = submitBtn.closest('.product-form__buttons') || submitBtn;
    var rafPending = false;

    function updateVisibility() {
      var threshold = docOffsetBottom(anchor);
      btn.classList.toggle('psc--visible', window.scrollY > threshold);
      rafPending = false;
    }

    window.addEventListener('scroll', function () {
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(updateVisibility);
      }
    }, { passive: true });

    window.addEventListener('resize', updateVisibility);
    window.addEventListener('load', updateVisibility);
    updateVisibility();

    // Idle wiggle every 4.5 s when visible
    setInterval(function () {
      if (!btn.classList.contains('psc--visible')) return;
      if (btn.classList.contains('psc--success') || btn.classList.contains('psc--idle')) return;
      btn.classList.add('psc--idle');
      setTimeout(function () { btn.classList.remove('psc--idle'); }, 750);
    }, 4500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Success animation after cart add
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (!data || data.source !== 'product-form') return;
      if (!pscTriggered) return;
      pscTriggered = false;
      var btn = document.querySelector('.psc-btn');
      if (btn && btn.classList.contains('psc--visible')) showSuccess(btn);
    });
  }
})();
